export const sideMenuItems = [
  {
    title: "Admin",
    icon: (
      <img src={require("../assets/logos/Admin.svg").default} alt="admin" />
    ),
    activeIcon: (
      <img
        src={require("../assets/logos/Admin_active.svg").default}
        alt="adminActive"
      />
    ),
    url: "/dashboard",
  },
  {
    title: "My Packages",
    icon: (
      <img
        src={require("../assets/logos/my_packages.svg").default}
        alt="admin"
      />
    ),
    activeIcon: (
      <img
        src={require("../assets/logos/my_packages_active.svg").default}
        alt="adminActive"
      />
    ),
    items: [
      {
        title: "My Delivery",
        icon: (
          <img
            src={require("../assets/logos/my_delivery.svg").default}
            alt="admin"
          />
        ),
        activeIcon: (
          <img
            src={require("../assets/logos/my_delivery_active.svg").default}
            alt="adminActive"
          />
        ),
        url: "/MyDelivery",
      },
      {
        title: "My Request",
        icon: (
          <img
            src={require("../assets/logos/my_request.svg").default}
            alt="admin"
          />
        ),
        activeIcon: (
          <img
            src={require("../assets/logos/my_request_active.svg").default}
            alt="adminActive"
          />
        ),
        url: "/MyRequest",
      },
    ],
  },
  {
    title: "Users",
    icon: (
      <img src={require("../assets/logos/users.svg").default} alt="admin" />
    ),
    activeIcon: (
      <img
        src={require("../assets/logos/users_active.svg").default}
        alt="adminActive"
      />
    ),
    url: "/users",
  },
  {
    title: "Notifications",
    icon: (
      <img
        src={require("../assets/logos/notification.svg").default}
        alt="admin"
      />
    ),
    activeIcon: (
      <img
        src={require("../assets/logos/notification_active.svg").default}
        alt="adminActive"
      />
    ),
    notifyIcon: (
      <img src={require("../assets/logos/bell.svg").default} alt="admin" />
    ),
    url: "/notifications",
  },
];

export const userMenuItems = [
  {
    title: "My Delivery",
    icon: (
      <img
        src={require("../assets/logos/my_delivery.svg").default}
        alt="admin"
      />
    ),
    activeIcon: (
      <img
        src={require("../assets/logos/my_delivery_active.svg").default}
        alt="adminActive"
      />
    ),
    url: "/MyDelivery",
  },
  {
    title: "My Request",
    icon: (
      <img
        src={require("../assets/logos/my_request.svg").default}
        alt="admin"
      />
    ),
    activeIcon: (
      <img
        src={require("../assets/logos/my_request_active.svg").default}
        alt="adminActive"
      />
    ),
    url: "/MyRequest",
  },
  {
    title: "Notifications",
    icon: (
      <img
        src={require("../assets/logos/notification.svg").default}
        alt="admin"
      />
    ),
    activeIcon: (
      <img
        src={require("../assets/logos/notification_active.svg").default}
        alt="adminActive"
      />
    ),
    notifyIcon: (
      <img src={require("../assets/logos/bell.svg").default} alt="admin" />
    ),
    url: "/notifications",
  },
];

export const adminMenuItems = {
  title: "Admin Profile",
  icon: (
    <img
      src={require("../assets/logos/profile_with_circle.svg").default}
      alt="admin"
    />
  ),
  activeIcon: (
    <img
      src={require("../assets/logos/profile_with_circle.svg").default}
      alt="adminActive"
    />
  ),
  url: "/profile",
};

export const profileMenuItems = {
  title: "My Profile",
  icon: (
    <img
      src={require("../assets/logos/profile_with_circle.svg").default}
      alt="admin"
    />
  ),
  activeIcon: (
    <img
      src={require("../assets/logos/profile_with_circle.svg").default}
      alt="adminActive"
    />
  ),
  url: "/profile",
};

export const logoutMenuItems = {
  title: "Logout",
  icon: <img src={require("../assets/logos/logout.svg").default} alt="admin" />,
};
